// extracted by mini-css-extract-plugin
export default {"rateTitle":"RateList_rateTitle__HbZRA","tooltipHeader":"RateList_tooltipHeader__+9JzC","ratesWrapper":"RateList_ratesWrapper__SAhUy"};